function menuState(menu) {
	var isOpen = false;
	for (var x = 0; x < menu.length; x++)
		menu[x] != false ? isOpen = true : false;
	return isOpen;
}

window.scrollLock = function (menu) {
	if ( menuState(menu) ) {
		document.body.classList.add('overflow-hidden', 'md:overflow-visible');
		document.querySelector('nav').classList.remove('shadow-lg');
	} else {
		document.body.classList.remove('overflow-hidden', 'md:overflow-visible');
		document.querySelector('nav').classList.add('shadow-lg');
	}
}